// extracted by mini-css-extract-plugin
export default {"uplink":"tam3","downlink":"Zq63","policy":"mve3"};